import { FixtureConfig } from '../types';

export function getSport(fixtureConfig: FixtureConfig | undefined) {
  return fixtureConfig && fixtureConfig.fixture && fixtureConfig.fixture.sport;
}
